/**
 * Mirrors `packages/hump-club/src/shared/utils/phone.ts` `normalizeMobile` so the web app
 * can key session storage by the same string the API returns without importing hump-club TS
 * through Next.js webpack (which does not transpile that package path).
 */
export function normalizeAuMobile(input?: string | null): string | null {
  if (!input) return null
  const trimmed = input.trim()
  if (!trimmed) return null

  const stripped = trimmed.startsWith('+')
    ? `+${trimmed.slice(1).replace(/\D/g, '')}`
    : trimmed.replace(/\D/g, '')

  if (!stripped) return null
  if (stripped.startsWith('+61')) return `0${stripped.slice(3)}`
  if (stripped.startsWith('61')) return `0${stripped.slice(2)}`
  return stripped
}
